import * as styles from "./PageHeader.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { PageHeaderProps } from "./PageHeader.types";
import { PageHeaderVisual } from "./PageHeaderVisual";
import { PAGE_HEADER_SLOT } from "./constants";

export function PageHeader({
  icon,
  variant = "card",
  children,
  className,
}: PageHeaderProps): JSX.Element {
  return (
    <header
      data-slot={PAGE_HEADER_SLOT}
      className={clsx(styles.header({ variant }), className)}
    >
      {icon && <PageHeaderVisual icon={icon} variant={variant} />}

      {children}
    </header>
  );
}
